// extracted by mini-css-extract-plugin
export var activeFilterButton = "_m0-c";
export var backButton = "_m0-4";
export var backIcon = "_m0-5";
export var chevronShortcut = "_m0-6";
export var container = "_m0-1";
export var editor = "_m0-8";
export var editorWrapper = "_m0-7";
export var prefix = "_m0-2";
export var searchIcon = "_m0-3";
export var suffix = "_m0-9";
export var suffixContent = "_m0-a";
export var suffixText = "_m0-b";
export var wrapper = "_m0-0";